import cmsSettings from '../cmsSettings'
import { imageAsset, link } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  ${imageAsset.fragment('sectionBackgroundImage')},
  ${imageAsset.fragment('image')},
  title[]{
    ...,
    markDefs[]{
      ...,
      _type == "link" => {
        ${link.fields}
      },
    },
    _type == "link" => {
      ${link.fields}
    },
  },  
  titleColor,
  content[]{
    ...,
    markDefs[]{
      ...,
      _type == "link" => {
        ${link.fields}
      },
    },
    _type == "link" => {
      ${link.fields}
    },
  },
  contentOrientation,
  ${link.fragment('primaryCta')},
  ${link.fragment('secondaryCta')}
`

export const fragment = (name = 'featuredTextBlock') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
